import React from 'react';
import { isEmpty as _isEmpty, map as _map, isEqual as _isEqual } from 'lodash-es';
import { Tag } from 'antd';
import { useLocation,Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Icon from 'components/Icon';
import { DashboardConfigConstants } from 'redux/DashboardConfig/DashboardConfig.constants';
import { useTranslation } from 'react-i18next';
import './SubmenuSection.scss';
import queryString from 'query-string';

const isExternalRoutesList = [
  'nav_execute_product_master',
  'nav_execute_automation',
  'nav_execute_campaigns'
];

const unWantedRoutesList = [
  'nav_execute_product_master',
  'nav_execute_batch_listing',
  'nav_execute_automation',
  'nav_execute_campaigns',
  'nav_analyze_users',
  'nav_analyze_order_income',
  'nav_analyze_invoices',
  'nav_analyze_target_planning',
  'nav_analyze_competitors'
];

const unWantedParentRoutesList = ['nav_finance_section'];

const isBetaRoutes = ['nav_execute_chat', 'nav_execute_batch_listing'];
const skippedAnalyzeSideMenus = ['nav_analyze_deepdive', 'nav_analyze_marketing_deepdive'];
const SubmenuSection = ({ data, isDataLakeReady }) => {
  const dispatch = useDispatch(queryString);
  const { t } = useTranslation();
  const location = useLocation();
  const nickNameList = useSelector(state => state.Account?.stores?.nicknames);
  const hasWriteAccess = useSelector(state => state?.Account?.hasWriteAccess);

  const isMenuActive = (menuPath) => {
    const pathname = location.pathname;
    // chart builder condition
     if ((menuPath === '/analyze/workspace' && pathname.includes('/chart-builder'))) {
      return true;
     }
    // pages with submenu condition
    else {
      const menuSegments = menuPath.split('/');
      const pathSegments = pathname.split('/');
      return menuSegments[2] === pathSegments[2];
    } 

  };

  if (_isEmpty(data?.menu)) return null;

  if (!hasWriteAccess && unWantedParentRoutesList.includes(data?.id)) return null;

  return (
    <div className='sidebar_section'>
      {!_isEmpty(data?.sectionHeading) && <h4 className='sidebar_section_heading'>{data?.sectionHeading}</h4>}

      <div className='sidebar_section_menus'>
        {!_isEmpty(data?.menu) &&
          _map(data?.menu, subMenu => {
            if (!hasWriteAccess && unWantedRoutesList.includes(subMenu?.id)) return;
            if (isExternalRoutesList.includes(subMenu?.id)) {
              // ! This logic should not be handled on frontend.
              // ! Menu API should not send this submenu if condition not matched.
              let hasEbayNick = nickNameList?.some(nick => nick?.id.includes('eBay'));
              if (subMenu?.id === 'nav_execute_automation' && !hasEbayNick) return;
              // ! Till here - Informed to Pankaj.

              return (
                <button
                  qa-data={subMenu?.label}
                  className={`menu_item ${window.location.href.includes(subMenu?.path) && 'active'}`}
                  key={subMenu?.id}
                  onClick={() => window.location.replace(subMenu?.path)}
                >
                  <div className='menu_item_icon'>
                    <Icon name={subMenu?.icon || 'ballot'} size='default' />
                  </div>
                  <div className='menu_item_title'>
                    {subMenu?.label}&nbsp;
                    {isBetaRoutes?.includes(subMenu?.id) && <Tag className='c-beta-tag'>{t('GRAAS_BETA_GRAAS')}</Tag>}
                  </div>
                </button>
              );
            } else {
              // this code change is only for tempory fix to prevent deep dive menu.
              // if(!isDataLakeReady && skippedAnalyzeSideMenus.includes(subMenu?.id)) {
              //   return (
              //     <NavLink
              //       activeclassname='active'
              //       to={{}}
              //       className='menu_item disableMenu'
              //       key={subMenu?.id}
              //       onClick={e => dispatch({type:DashboardConfigConstants.SET_SELECTED_SUBMENU, payload:subMenu?.path})}
              //       {...configs}
              //     >
              //       <div className='menu_item_icon'>
              //         <Icon name={subMenu?.icon || 'ballot'} />
              //       </div>
              //       <div className='menu_item_title'>
              //         {subMenu?.label}
              //         <span className='c-tag is-low'>{t('GRAAS_COMING_SOON_GRAAS')}</span>
              //       </div>
              //     </NavLink>
              //   );
              // }
             
              return (
                <Link
                  to={{ pathname: !subMenu?.path?.includes('/#') ? subMenu?.path : undefined, state: { message: subMenu?.note, isEnabled: subMenu?.isEnabled } }}
                  className={`menu_item ${isMenuActive(subMenu?.path) ? 'active' : ''}`}
                  key={subMenu?.id}
                  onClick={e => {
                    if (subMenu.isNewTab) {
                      e.preventDefault();
                      window.open(subMenu?.path, '_blank', 'noopener,noreferrer');
                    } else {
                      dispatch({ type: DashboardConfigConstants.SET_SELECTED_SUBMENU, payload: subMenu?.path });
                    }
                  }}
                  qa-data={subMenu?.label}
                >
                  <div className='menu_item_icon'>
                    <Icon name={subMenu?.icon || 'ballot'} size='default' />
                  </div>
                  <div className='menu_item_title'>
                    {subMenu?.label}&nbsp;
                    {isBetaRoutes?.includes(subMenu?.id) && <Tag className='c-beta-tag'>{t('GRAAS_BETA_GRAAS')}</Tag>}
                  </div>
                </Link>
              );
            }
          })}
      </div>
    </div>
  );
};

export default SubmenuSection;
